import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20" aria-label="主题分类">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            kicker="六大主题"
            title="先挑一个方向，再慢慢讲"
            desc="每条爆料都归属一个主题分类。选个最贴近的，其他人更容易在广场里找到你的内容。"
          />
          <Link
            to="/feed"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap font-label text-sm text-primary-700 transition-colors hover:text-primary-800"
          >
            查看全部分类
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/feed?category=${category.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${category.icon} text-xl`} aria-hidden="true" />
                </span>
                <span className="font-display text-lg text-secondary-400">{category.count}</span>
              </div>
              <h3 className="mt-5 font-display text-lg text-foreground-950">{category.label}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 font-label text-xs text-secondary-600">
                条爆料在等你看
                <i className="ri-arrow-right-up-line" aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}